import * as L from 'leaflet';

import { MeterBuildingAlarm } from '@app/energy-guard/models/alarms';
import { ComponentRef } from '@angular/core';
import { EnergyMapBuilding } from './energy-map-building';
import { EnergyTypeProducers } from './energy-type-producers';

export const EPMarker = L.Marker.extend({
  id: '',
}) as any;

export interface EnergyMarker extends EnergyMapBuilding {
  alarms: MeterBuildingAlarm;
  component: ComponentRef<any>;
  fullAddress?: string;
  icon: string;
  isBuildingEnergyGuardLicensed: boolean;
  isEnergyGuardNotificationActive: boolean;
  marker: L.Marker;
  type: string;
}

export interface EnergyTypeMarker extends EnergyTypeProducers {
  component: ComponentRef<any>;
  icon: string;
  marker: L.Marker;
}
